const REGISTRY = new Map();
/** Called once per kind, at module load, by each owning module's `kinds/<module>.ts`. */
export function registerNotificationKind(definition) {
    if (REGISTRY.has(definition.kind)) {
        throw new Error(`notification kind already registered: ${definition.kind}`);
    }
    REGISTRY.set(definition.kind, definition);
}
export function notificationKind(kind) {
    return REGISTRY.get(kind);
}
export function isRegisteredNotificationKind(kind) {
    return REGISTRY.has(kind);
}
/** Test-only: lets a suite reset the registry between files that register conflicting fakes. */
export function clearNotificationKindRegistry() {
    REGISTRY.clear();
}
//# sourceMappingURL=registry.js.map